import { render, staticRenderFns } from "./AssProduto.vue?vue&type=template&id=286ee1d6&scoped=true"
import script from "./AssProduto.vue?vue&type=script&lang=js"
export * from "./AssProduto.vue?vue&type=script&lang=js"
import style0 from "./AssProduto.vue?vue&type=style&index=0&id=286ee1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ee1d6",
  null
  
)

export default component.exports